import Text from "components/atoms/text";
import Loader from "components/molecules/loader";
import { useConfig } from "context/configContext";
import { useNav } from "context/navContext";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { decode, device, getUserInfo } from "utils/helperFunctions";
import { getSessionStorage } from "utils/storageUtil";
import AdyenDropIn from "./adyenDropIn";
import BraintreeDropIn from "./braintreeDropIn";

const PaymentDropIn = (props) => {
  const history = useHistory();
  const { currency } = useConfig();
  const { setShowHeader } = useNav();

  const [paymentSession] = useState(
    props?.location?.state?.data?.paymentSession
  );
  const [invoice] = useState(props?.location?.state?.data?.invoice);
  const [clientSecret] = useState(atob(invoice?.clientSecret));

  const [isLoading, setIsLoading] = useState(false);
  const [orderId] = useState(props?.location?.state?.data?.orderId);
  const [orderAmount] = useState(props?.location?.state?.data?.orderAmount);
  const [paymentGateway] = useState(
    props?.location?.state?.data?.paymentGateway
  );

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [phNo, setPhNo] = useState("");

  useEffect(() => {
    getUserDetails();
  }, []);

  useEffect(() => {
    setShowHeader(false);
    return () => {
      setShowHeader(true);
    };
  }, []);

  const getUserDetails = async () => {
    try {
      let apiData = await getUserInfo("both");
      let data = apiData.data;
      if (data?.segment?.code === "G") {
        const guestData = getSessionStorage("guestUserData") || {};
        if (guestData && Object.keys(guestData)?.length > 0) {
          setFirstName(
            guestData.firstName !== null && guestData.firstName !== undefined
              ? guestData.firstName
              : ""
          );
          setLastName(
            guestData.lastName !== null && guestData.lastName !== undefined
              ? guestData.lastName
              : ""
          );

          if (guestData.email !== null && guestData.email !== undefined) {
            setEmail(guestData.email);
          }

          if (guestData.mobile !== null && guestData.mobile !== undefined) {
            setPhNo(`${guestData?.countryCode}${guestData.mobile}`);
          }
        }
      } else {
        if (data) {
          setFirstName(
            data.firstName !== null && data.firstName !== undefined
              ? data.firstName
              : ""
          );
          setLastName(
            data.lastName !== null && data.lastName !== undefined
              ? data.lastName
              : ""
          );

          if (data.email !== null && data.email !== undefined) {
            setEmail(decode(data.email));
          }

          if (data.mobile !== null && data.mobile !== undefined) {
            setPhNo(`${data?.countryCode}${decode(data.mobile)}`);
          }
        }
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const renderPaymentDropIn = () => {
    if (paymentGateway === "adyen") {
      return (
        <AdyenDropIn
          clientSecret={clientSecret}
          paymentSession={paymentSession}
          currency={currency}
          handlePaymentCompleted={handlePaymentCompleted}
          handlePaymentFailed={handlePaymentFailed}
          handlePaymentError={handlePaymentError}
          disabled={isDropInDisabled()}
        />
      );
    } else if (paymentGateway === "braintree") {
      return (
        <BraintreeDropIn
          clientSecret={clientSecret}
          paymentSession={paymentSession}
          currency={currency}
          handlePaymentCompleted={handlePaymentCompleted}
          handlePaymentFailed={handlePaymentFailed}
          handlePaymentError={handlePaymentError}
          disabled={isDropInDisabled()}
          orderId={orderId}
          orderAmount={orderAmount}
        />
      );
    } else {
      return (
        <AdyenDropIn
          clientSecret={clientSecret}
          paymentSession={paymentSession}
          handlePaymentCompleted={handlePaymentCompleted}
          handlePaymentFailed={handlePaymentFailed}
          handlePaymentError={handlePaymentError}
          disabled={isDropInDisabled()}
        />
      );
    }
  };

  const isDropInDisabled = () => {
    if (firstName === "" || lastName === "" || phNo === "" || email === "") {
      return true;
    } else {
      return false;
    }
  };

  const handlePaymentCompleted = () => {
    history.replace(`/paymentSuccess/${orderId}`);
  };

  const handlePaymentFailed = () => {
    history.replace(`/paymentFailure/${orderId}`);
  };

  const handlePaymentError = () => {
    history.replace(`/paymentFailure/${orderId}`);
  };

  if (isLoading) {
    return <Loader />;
  } else {
    return (
      <PageWrapper>
        <ContentContainer>
          <FormContainer>
            <FormRow>
              <InputWrapper>
                <TextField
                  placeholder="First Name"
                  type="text"
                  value={firstName}
                  onChange={(event) => {
                    setFirstName(
                      event.target.value.replace(/[^ a-zA-Z]+/gi, "")
                    );
                  }}
                  autoComplete="off"
                />
              </InputWrapper>
              <InputWrapper>
                <TextField
                  placeholder="Last Name"
                  type="text"
                  value={lastName}
                  onChange={(event) => {
                    setLastName(
                      event.target.value.replace(/[^ a-zA-Z]+/gi, "")
                    );
                  }}
                  autoComplete="off"
                />
              </InputWrapper>
            </FormRow>
            <FormRow>
              <InputWrapper>
                <TextField
                  placeholder="Phone Number"
                  type="text"
                  maxLength="15"
                  value={phNo}
                  onChange={(event) => setPhNo(event.target.value)}
                  autoComplete="off"
                />
              </InputWrapper>
              <InputWrapper>
                <TextField
                  placeholder="Email"
                  type="text"
                  maxLength="62"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  autoComplete="off"
                />
              </InputWrapper>
            </FormRow>
          </FormContainer>
          <DropInContainer>
            {isDropInDisabled() && (
              <DropInMask>
                <Text type="semi-bold">
                  Please fill out all required fields
                </Text>
              </DropInMask>
            )}
            <DropInWrapper disabled={isDropInDisabled()}>
              {renderPaymentDropIn()}
            </DropInWrapper>
          </DropInContainer>
        </ContentContainer>
      </PageWrapper>
    );
  }
};

const PageWrapper = styled.div`
  width: 100vw;
  position: relative;
`;
const ContentContainer = styled.div`
  padding: 24px;

  @media ${device.laptop} {
    padding: 24px 72px;
  }

  @media ${device.laptopL} {
    padding: 24px 136px;
  }
`;
const FormContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  gap: 24px 0px;
`;
const FormRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${device.laptop} {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;
const TextField = styled.input`
  width: calc(100% - 32px);
  height: 54px;
  padding: 0px 16px;
  border: 1px solid #dcdcdc;
  border-radius: 8px;
  opacity: ${({ disabled }) => (disabled ? 0.7 : 1)};
  font-size: 16px;
  font-family: "ManropeMedium";
`;
const InputWrapper = styled.div`
  width: 100%;

  @media ${device.laptop} {
    width: 50%;
  }
`;
const DropInContainer = styled.div`
  width: 100%;
  margin-top: 24px;
  position: relative;
`;
const DropInWrapper = styled.div`
  width: 100%;
  position: relative;
  pointer-events: ${({ disabled }) => (disabled ? "none" : "all")};
`;
const DropInMask = styled.div`
  pointer-events: none;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: rgba(233, 230, 237, 0.7);
  z-index: 10;

  font-size: 16px;
`;

export default PaymentDropIn;
